/**
 * Created by or_p on 6/18/2016.
 */
import {stringToDashed} from 'cl-automation-utils';
import GlobalStore from 'crazyEditor/components/ElementsDialogs/ImageDialog/GlobalStore';
import PropTypes from 'prop-types';

import React, {Component} from 'react';
import Dialog from 'material-ui/Dialog';
import * as Colors from 'material-ui/styles/colors';
import styles from './BaseElementDialogStyles';
import FontIcon from 'material-ui/FontIcon';
import IconButton from 'material-ui/IconButton';
import _ from 'lodash';
import * as Consts from '../common/Consts';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';

export default class BaseElementDialog extends Component {
  constructor(props) {
    super(props);

    this.onCancel = this.onCancel.bind(this);
    this.onAddUpdate = this.onAddUpdate.bind(this);
  }

  onAddUpdate() {
    const {onAddUpdate} = this.props;
    if (onAddUpdate) {
      onAddUpdate();
    }
  }

  onCancel(force = false) {
    const {onCancel} = this.props;
    if (onCancel) {
      onCancel(force);
    }
  }

  render() {
    const {
      children,
      title,
      newElement,
      inputValid,
      secondaryButtonLabel,
      contentStyle,
      innerDivStyle,
      buttonsSectionStyle,
    } = this.props;
    let {primaryButtonLabel} = this.props;
    if (_.isEmpty(primaryButtonLabel)) {
      primaryButtonLabel = newElement ? 'add to page' : 'update';
    }
    return (
      <Dialog
        {..._.omit(this.props, ['title'])}
        bodyStyle={{padding: 0}}
        contentStyle={{
          maxHeight: Consts.MUI_DIALOG_MAX_HEIGHT,
          maxWidth: Consts.DIALOG_WIDTH,
          width: Consts.DIALOG_WIDTH,
          padding: 0,
          position: 'relative',
          height: Consts.DIALOG_HEIGHT,
          ...contentStyle,
        }}
      >
        <GlobalStore>
          <header style={styles.title}>
            {title}
            <IconButton id="cla-x" onClick={this.onCancel.bind(this, true)} iconStyle={{color: Colors.white}}>
              <FontIcon className="material-icons">close</FontIcon>
            </IconButton>
          </header>
          <div style={{...styles.content, ...innerDivStyle}} ref="content">
            {children}
          </div>
          <div style={{...styles.buttonsSection, ...buttonsSectionStyle}}>
            <FlatButton
              id={`cla-btn-${stringToDashed(secondaryButtonLabel)}`}
              style={{marginRight: 20}}
              primary
              label={secondaryButtonLabel}
              onClick={this.onCancel}
            />
            <RaisedButton
              id={`cla-btn-${stringToDashed(primaryButtonLabel.toLowerCase())}`}
              disabled={!inputValid}
              style={styles.mainButton}
              primary
              onClick={this.onAddUpdate}
              label={primaryButtonLabel}
            />
          </div>
        </GlobalStore>
      </Dialog>
    );
  }
}

BaseElementDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  inputValid: PropTypes.bool,
  newElement: PropTypes.bool,
  onCancel: PropTypes.func,
  onAddUpdate: PropTypes.func,
  secondaryButtonLabel: PropTypes.string.isRequired,
  primaryButtonLabel: PropTypes.string,
};

BaseElementDialog.defaultProps = {
  valid: true,
  newElement: false,
  secondaryButtonLabel: 'cancel',
};
